// extracted by mini-css-extract-plugin
module.exports = {"loadingContainer":"ActiveSurvey_loadingContainer__3KY-w"};